<div
    class="w-full h-full fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center flex-col bg-black bg-opacity-70 z-50">
    <div class="inline-block h-32 w-32 animate-spin rounded-full border-4 border-solid border-button-primary border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
        <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
    </div>
</div>